/**
 * [新游期待榜、热门游戏榜]
 */
if ($('.js-rank').length) {
    $('.js-rank').each(function() {
        var currentObj, _this = $(this);
        for (var i = 0; i < $('li', _this).length; i++) {
            currentObj = $('li:eq(' + i + ')', _this);
            currentObj.mouseenter(function() {
                $(this).addClass('active').siblings().removeClass('active');
            }).find('.c1 em').html(i + 1);
        }
        $('li:eq(0)', _this).addClass('active');
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/component/rank.js
// module id = 5
// module chunks = 0